import {sortOnDate} from '@/shared/utils/classroom.js';
import {
    ACCREDITATIONINFO_LOAD,
    ACCREDITATIONINFO_UPDATE,
    ACCREDITATIONINFO_CREATE,
    ACCREDITATIONINFO_REMOVE,
    ACCREDITATIONINFO_OPEN,
    ACCREDITATIONINFO_SAVE,
    ACCREDITATIONINFO_ORGANIZATIONS_LOAD,
} from '@/accreditation/actions/accreditationInfo.js';

const app = (state = {}, action) => {
    const {type, payload} = action;
    let index;
    let changes;
    let value;

    switch (type) {
        case `${ACCREDITATIONINFO_LOAD}_PENDING`:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case `${ACCREDITATIONINFO_LOAD}_FULFILLED`: {
            const {accreditations = [], organizations = [], suppliers = []} = payload ?? {};

            return {
                ...state,
                loading: false,
                error: false,
                current: sortOnDate([...accreditations], 'validFrom', true),
                organizations: [...organizations],
                suppliers: [...suppliers],
                dirty: false,
            };
        }
        case `${ACCREDITATIONINFO_LOAD}_REJECTED`: {
            return {
                ...state,
                loading: false,
                error: payload,
                current: [],
                organizations: [],
                suppliers: [],
            };
        }
        case ACCREDITATIONINFO_UPDATE:
            ({index, changes} = payload);
            return {
                ...state,
                current: state.current.map((o, i) =>
                    i === index ? _deepExtend(o, {...changes, $dirty: true}) : o,
                ),
                dirty: true,
            };
        case ACCREDITATIONINFO_CREATE:
            return {
                ...state,
                current: [{...payload, $opened: true}, ...state.current],
                dirty: true,
            };
        case ACCREDITATIONINFO_REMOVE:
            ({index} = payload);

            return {
                ...state,
                current: state.current.filter((_, i) => i !== index),
                dirty: true,
            };
        case ACCREDITATIONINFO_OPEN:
            ({value, index} = payload);

            return {
                ...state,
                current: state.current.map((o, i) => (i === index ? {...o, $opened: value} : o)),
            };
        case `${ACCREDITATIONINFO_SAVE}_PENDING`:
            return {
                ...state,
                save: 'pending',
                error: false,
            };
        case `${ACCREDITATIONINFO_SAVE}_FULFILLED`:
            return {
                ...state,
                save: 'success',
                error: false,
                current: sortOnDate(
                    state.current.map((m) => ({...m, $dirty: false, $opened: false})),
                    'validFrom',
                    true,
                ),
                dirty: false,
            };
        case `${ACCREDITATIONINFO_SAVE}_REJECTED`:
            return {
                ...state,
                save: 'failed',
                error: payload,
            };
        case `${ACCREDITATIONINFO_ORGANIZATIONS_LOAD}_PENDING`:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case `${ACCREDITATIONINFO_ORGANIZATIONS_LOAD}_FULFILLED`: {
            return {
                ...state,
                loading: false,
                error: false,
                organizations: [...payload],
                dirty: false,
            };
        }
        case `${ACCREDITATIONINFO_ORGANIZATIONS_LOAD}_REJECTED`: {
            return {
                ...state,
                loading: false,
                error: payload,
                organizations: [],
            };
        }
        default:
            return state;
    }
};

const _deepExtend = (target, ...changes) => {
    if (!changes.length) {
        return target;
    }
    const source = changes.shift();

    if (_isObject(target) && _isObject(source)) {
        for (const key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = _isObject(source[key])
                    ? _deepExtend(target[key] || {}, source[key])
                    : (target[key] = source[key]);
            }
        }
    }
    return _deepExtend(target, ...changes);
};

const _isObject = (obj) => {
    return obj !== null && typeof obj === 'object';
};

export default app;
